import * as Yup from 'yup';
import { PARTNER_TOKEN_LENGTH } from './PartnerTokenExchange.constants';

// Mirrors the backend rules so most mistakes are caught before submitting.
export const partnerTokenExchangeSchema = () =>
  Yup.object({
    token: Yup.string().trim().required().length(PARTNER_TOKEN_LENGTH),
    redirectUri: Yup.string()
      .trim()
      .required()
      .url({ key: 'pagePartnerTokenExchange.validation.invalidUri' })
      .test(
        'https-scheme',
        { key: 'pagePartnerTokenExchange.validation.httpsRequired' },
        (value) => !value || value.toLowerCase().startsWith('https://'),
      )
      .test(
        'no-query',
        { key: 'pagePartnerTokenExchange.validation.queryNotAllowed' },
        (value) => !value || !value.includes('?'),
      ),
  });

export type PartnerTokenExchangeSchemaType = Yup.InferType<
  ReturnType<typeof partnerTokenExchangeSchema>
>;
